/**
 * The sensitivities for a Diagnosis–Symptom relationship.
 *
 * @author jonmd
 */
class Sensitivity {
  static RARE: Sensitivity;
  static UNCOMMON: Sensitivity;
  static DEFAULT: Sensitivity;
  static IMPORTANT: Sensitivity;
  static ESSENTIAL: Sensitivity;

  private static _values: Sensitivity[] = [];
  private static _lookup: Map<number, Sensitivity> = new Map();

  static fromId(id?: number) {
    const sensitivity = Sensitivity._lookup.get(id !== undefined ? id : -1);
    if (sensitivity === undefined) {
      throw new Error('Not a valid Sensitivity.id: ' + id);
    }
    return sensitivity;
  }

  static values(): Sensitivity[] {
    return [...Sensitivity._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    Sensitivity._values.push(this);
    Sensitivity._lookup.set(id, this);
  }

  toString() {
    return '<Sensitivity: id=' + this.id + ', label=' + this.label + '>';
  }
}

Sensitivity.RARE = new Sensitivity(1, 'Rare');
Sensitivity.UNCOMMON = new Sensitivity(2, 'Uncommon');
Sensitivity.DEFAULT = new Sensitivity(3, 'Average');
Sensitivity.IMPORTANT = new Sensitivity(4, 'Important');
Sensitivity.ESSENTIAL = new Sensitivity(5, 'Essential');

export { Sensitivity };
